import React, { useState, useEffect } from "react";
import {
  Alert,
  Form,
  Button,
  ButtonGroup,
  Card,
  Spinner,
  Modal,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import {
  getEmpChecklist,
  saveCheckListEmployee,
  editCheckListEmployee,
  deleteCheckListEmployee,
  editCheckListDocGD,
  saveCheckListDocGD,
} from "../../../redux/employeeDocsChecklist/actions";
import { getChecklist } from "../../../redux/checklist/actions";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/SidebarConfig";
import CustomTable from "../../../components/CustomTable";
import messages from "../../../redux/messages";
import UserMenuComponent from "../../../components/profile/UserMenuComponent";
import { getBase64 } from "../../../components/gestorDocumental/GestorDocumental";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import { getEmployee } from "../../../redux/employees/actions";
import {
  getAreas,
  getCarpetas,
  getDocs,
  getSubNiveles,
} from "../../../redux/gestorDocumental/actions";
import config from "../../../config";
import LinkDescargaGD from "../../../components/gestorDocumental/LinkDescargaGD";

const DocsCheckList = (props) => {
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);

  const [validFechaDoc, setValidFechaDoc] = useState(false);
  const [habilitarFecha, setHabilitarFecha] = useState(false);
  const [showModalView, setShowModalView] = useState(false);

  //Redux
  const dispatch = useDispatch();
  //EmpChecklist
  const loading = useSelector((store) => store.employeeDocsCheckList.loading);
  const saveLoader = useSelector(
    (store) => store.employeeDocsCheckList.saveLoader
  );
  const data = useSelector((store) => store.employeeDocsCheckList.checklistEmp);
  const docs = useSelector((store) => store.checklistDocs.checklist);
  const checkListLoader = useSelector((store) => store.checklistDocs.loading);
  const userInfo = useSelector((store) => store.employees.employee);
  const userId = useSelector((store) => store.auth.id);

  const {
    areas,
    carpetas,
    subNiveles,
    areasError,
    carpetasError,
    error,
    formErrors,
    loaderSubNiveles,
    loadingDocs,
    loadingAreas,
    loadingCarpetas,
    saveDocsLoading,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);

  const { carpeta, tipoDocumentoGD, tipoDocumento, descripcion } =
    config.gestorDocumental.checklist;
  const { area, email } = config.gestorDocumental;

  const columns = [
    {
      Header: "Documento",
      accessor: "check_name",
    },
    {
      Header: "Fecha",
      Cell: (value) => moment(value.row.original.fecha).format("DD/MM/YYYY"),
    },
    {
      id: "customActive",
      Filter: "",
      Cell: (value) => (
        <Form>
          <Form.Check
            //disabled={saveLoader}
            type="switch"
            id={`ckbActive${value.row.original.id}`}
            defaultChecked={value.row.original.activo}
            onChange={(e) =>
              onChangeActive(
                e.target.checked,
                value.row.original,
                value.row.index
              )
            }
          />
        </Form>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          {!value.row.original.activo && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip {...props}>Subir archivo</Tooltip>}
            >
              <Button
                size="sm"
                variant="link"
                type="button"
                className="text-primary btn rounded-pill"
                onClick={() => onViewImg(value.row.original, index)}
              >
                <i className="material-icons">upload</i>
              </Button>
            </OverlayTrigger>
          )}
          {value.row.original.archivo_gestor && (
            <LinkDescargaListGD
              id={value.row.original.id}
              filters={{
                email: email,
                id: value.row.original.archivo_gestor[0].id_documento,
                llave: value.row.original.archivo_gestor[0].llave,
              }}
              origen={value.row.original.archivo_gestor[0].origen}
              icono={<i className="material-icons">file</i>}
              cType={value.row.original.archivo_gestor[0].contentTypeGD}
            />
          )}
        </div>
      ),
    },
  ];

  // Metodos
  useEffect(() => {
    dispatch(
      getEmpChecklist(
        parseInt(props.match.params.id),
        parseInt(props.match.params.type)
      )
    );
    dispatch(
      getEmployee(
        parseInt(props.match.params.id),
        parseInt(props.match.params.type)
      )
    );
    if (userId) {
      dispatch(
        getDocs({
          id_empleado: parseInt(props.match.params.id),
          tipo_documento: "checkList",
        })
      );
      dispatch(getAreas());
      dispatch(getCarpetas());
    }
  }, [dispatch, props.match.params.id, props.match.params.type, userId]);

  useEffect(
    () => dispatch(getChecklist(parseInt(props.match.params.type))),
    [dispatch, props.match.params.type]
  );

  useEffect(() => {
    if (areas && areas.length > 0 && carpetas && carpetas.length > 0) {
      const oCarpeta = carpetas.find(
        (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
      );
      dispatch(
        getSubNiveles({
          areaid: areas[0].id,
          ceid: oCarpeta.id,
        })
      );
    }
  }, [areas, carpetas]);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onViewImg = (item, index) => {
    if (docs.length > 0) {
      const oItem = docs.find((item) => item.id_registro === editItem.id);
      if (oItem !== undefined) {
        setEdit(true);
        setEditItem(oItem);
      } else {
        setEdit(false);
      }
    }
    setHabilitarFecha(false);
    setEditItem(item);
    setIndex(index);
    setShowModalView(true);
    setValidated(false);
  };

  const onChangeActive = (status, row, index) => {
    const odata = {
      id: row.id,
      fecha: row.fecha,
      activo: status,
      checklist: row.checklist,
      empleado: row.empleado,
    };
    dispatch(
      editCheckListEmployee(
        odata,
        parseInt(props.match.params.type),
        index,
        row.id
      )
    );
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const oData = {
      fecha: moment().format("YYYY-MM-DD"),
      activo: e.target.active.checked,
      checklist: e.target.checklist.value,
      empleado: parseInt(props.match.params.id),
    };

    if (edit) {
      dispatch(
        editCheckListEmployee(
          oData,
          parseInt(props.match.params.type),
          index,
          editItem.id
        )
      );
      setShowModal(false);
    } else {
      dispatch(saveCheckListEmployee(oData, parseInt(props.match.params.type)));
      e.target.reset();
      setShowModal(false);
    }
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(
        deleteCheckListEmployee(id, index, parseInt(props.match.params.type))
      );
    }
  };

  const onSubmitDocImg = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      if (
        e.target.documentos.files.length > 0 &&
        e.target.fechaDoc.value === ""
      ) {
        setValidFechaDoc(true);
      }
      setValidated(true);
      return;
    }
    if (
      e.target.documentos.files.length > 0 &&
      e.target.fechaDoc.value === ""
    ) {
      setValidFechaDoc(true);
      setValidated(true);
      return;
    }
    if (e.target.documentos.files.length === 0) {
      return;
    }

    const empresaT = userInfo.empresa[0];
    const oArea = areas.find(
      (item) => item.descripcion.toLowerCase() === area.toLowerCase()
    );
    const oCarpeta = carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );

    const filebase64 = await getBase64(e.target.documentos.files[0]);
    const fileName = e.target.documentos.files[0].name;
    const fName = String(fileName)
      .substring(0, String(fileName).lastIndexOf("."))
      .replace(/\W/g, "");
    const fExt = `.${String(fileName).substr(
      fileName.lastIndexOf(".") + 1 - fileName.length
    )}`;
    const aFileBase = String(filebase64).split(",");

    var chk = new FormData();
    chk.append("id_empleado", parseInt(props.match.params.id));
    chk.append("tipo_documento", tipoDocumento);
    chk.append("archivo", aFileBase[1]);
    chk.append("contentTypeGD", `${aFileBase[0]},`);
    chk.append("origen", fName + fExt);
    chk.append("extension", fExt);
    chk.append("tipo_documento_GD", e.target.tipoDocumentDesc.value);
    chk.append("descripcion", e.target.documentDesc.value);
    chk.append("fecha", moment().format("YYYY-MM-DD"));
    chk.append("id_area", oArea.id);
    chk.append("id_carpeta_encabezado", oCarpeta.id);
    chk.append("empresa", empresaT);
    chk.append("zona", userInfo.Division_Personal_List[0].descripcion);
    chk.append("id_registro", parseInt(editItem.id));
    const exist = e.target.documentos.files.length > 0;
    if (editItem && editItem.archivos_gestor) {
      dispatch(
        editCheckListDocGD(
          chk,
          editItem,
          index,
          parseInt(props.type),
          editItem.archivos_gestor,
          exist
        )
      );
    } else {
      dispatch(
        saveCheckListDocGD(
          chk,
          editItem,
          parseInt(index),
          parseInt(props.type),
          exist
        )
      );
    }
    e.target.reset();
    setEditItem({});
    setShowModalView(false);
  };

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">
              {props.match.params.name}
              <ButtonGroup>
                <Button onClick={props.history.goBack} size="sm">
                  <i className="material-icons">keyboard_return</i>
                </Button>
                <UserMenuComponent
                  id={props.match.params.id}
                  name={props.match.params.name}
                  type={props.match.params.type}
                />
                <Button size="small" onClick={() => onAdd()}>
                  <i className="material-icons">add</i>
                </Button>
              </ButtonGroup>
            </h2>
            <hr />
            <div className="d-flex justify-content-between aling-items-center">
              <h6>
                {parseInt(props.match.params.type) === 1
                  ? "Documentos formal"
                  : "Documentos funcional"}
              </h6>
              {saveLoader && (
                <Spinner animation="border" size="sm" variant="success" />
              )}
            </div>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={data} />
                </Card.Body>
              </Card>
            </>
          ) : (
            <Alert variant="info" className="my-4">
              No tiene documentos registrados, comience agregandolos.
            </Alert>
          )}
        </div>
      </div>
      <Modal show={showModal} size="md" onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? "Editar documento" : "Agregar documento"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="checklist">
              <Row className="align-items-center">
                <Col sm={checkListLoader ? "10" : "12"}>
                  <Form.Label className="ml-2">Documento</Form.Label>
                  <Form.Control
                    as="select"
                    id="checklist"
                    name="cheklist"
                    className="rounded-pill"
                    required
                    disabled={
                      parseInt(props.match.params.type) === 1 ? edit : false
                    }
                    defaultValue={edit ? editItem.checklist : null}
                    placeholder="Documento"
                  >
                    {docs.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nombre}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    **Campo requerido
                  </Form.Control.Feedback>
                </Col>
                {checkListLoader && (
                  <Col sm="2">
                    <Spinner animation="border" size="sm" />
                  </Col>
                )}
              </Row>
            </Form.Group>
            <Form.Group>
              <div className="d-flex aling-items-center justify-content-between px-2">
                <label htmlFor="active">Activo</label>
                <Form.Check
                  type="switch"
                  id="active"
                  name="active"
                  disabled={
                    parseInt(props.match.params.type) === 1 ? edit : false
                  }
                  checked={editItem.activo}
                />
              </div>
            </Form.Group>
            {editItem && editItem.archivo_gestor ? (
              <>
                <h6 className="text-muted ml-3">Archivo actual</h6>
                <ul className="list-unstyled">
                  <LinkDescargaGD
                    id={editItem.id}
                    filters={{
                      email: email,
                      id: editItem.archivo_gestor[0].id_documento,
                      llave: editItem.archivo_gestor[0].llave,
                    }}
                    origen={editItem.archivo_gestor[0].origen}
                    cType={editItem.archivo_gestor[0].contentTypeGD}
                  />
                </ul>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoader}
              variant="primary"
              type="submit"
            >
              {saveLoader ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal
        size="md"
        show={showModalView}
        onHide={() => {
          setShowModalView(false);
        }}
      >
        <Form onSubmit={onSubmitDocImg} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="font-weight-bold text-uppercase m-0">
                <i className="material-icons">file_upload</i>
                &nbsp;Subir archivo
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!formErrors && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {formErrors}
              </Alert>
            )}
            {!!subNivelesError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {subNivelesError}
              </Alert>
            )}
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Documento
              </Form.Label>
              <Col sm="12" md="8">
                <Form.File.Input
                  // accept="image/*"
                  name="documentos"
                  className="py-1"
                  required
                  disabled={
                    loadingDocs ||
                    loadingAreas ||
                    loadingCarpetas ||
                    saveDocsLoading ||
                    !(
                      subNiveles && subNiveles.subNivelTipoDocList.length > 0
                    ) ||
                    !(
                      subNiveles &&
                      subNiveles.subNivelDescripcionList.length > 0
                    )
                  }
                  onChange={(e) => {
                    if (e.currentTarget.files.length > 0) {
                      setHabilitarFecha(true);
                    } else {
                      setHabilitarFecha(false);
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  <ul className="list-unstyled">
                    <li>**Es requerido un archivo de menor peso.</li>
                    <li>**Es requerido un archivo con formato pdf o imagen.</li>
                  </ul>
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Descripción
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  as="select"
                  name="documentDesc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  // defaultValue={edit ? editItemGD.Descripcion : null}
                  placeholder="Descripción del documento"
                  disabled={!habilitarFecha}
                >
                  <option value="" selected disabled>
                    Seleccione un descripción
                  </option>
                  {subNiveles &&
                    subNiveles.subNivelDescripcionList &&
                    subNiveles.subNivelDescripcionList.map((item, index) => (
                      <option key={index} value={item.descripcion}>
                        {item.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Tipo de documento
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  as="select"
                  name="tipoDocumentDesc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  placeholder="Descripción del documento"
                  disabled={!habilitarFecha}
                >
                  <option value="" selected disabled>
                    Seleccione un tipo de documento
                  </option>
                  {subNiveles &&
                    subNiveles.subNivelTipoDocList &&
                    subNiveles.subNivelTipoDocList.map((item, index) => (
                      <option key={index} value={item.descripcion}>
                        {item.descripcion}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="12" md="4">
                Fecha de entrega
              </Form.Label>
              <Col sm="12" md="8">
                <Form.Control
                  name="fechaDoc"
                  className="rounded-pill"
                  required={validFechaDoc}
                  type="date"
                  disabled={!habilitarFecha}
                  defaultValue={"2024-01-02"}
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            {edit && editItem && editItem.archivo_gestor ? (
              <>
                <h6 className="text-muted ml-3">Archivo actual</h6>
                <ul className="list-unstyled">
                  <LinkDescargaGD
                    id={editItem.id}
                    filters={{
                      email: email,
                      id: editItem.archivo_gestor[0].id_documento,
                      llave: editItem.archivo_gestor[0].llave,
                    }}
                    origen={editItem.archivo_gestor[0].origen}
                    cType={editItem.archivo_gestor[0].contentTypeGD}
                  />
                </ul>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModalView(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={
                loadingDocs ||
                loadingAreas ||
                loadingCarpetas ||
                saveDocsLoading ||
                areas === "" ||
                (areas && areas.length === 0) ||
                carpetas === "" ||
                (carpetas && carpetas.length === 0)
              }
              variant="primary"
              type="submit"
            >
              {loadingDocs ||
              loadingAreas ||
              loadingCarpetas ||
              saveDocsLoading ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default withRouter(DocsCheckList);
